var _themes;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styled, { keyframes } from 'styled-components';
import { Visible16x16, Time16x16, Folder16x16, Collection16x16, ClosedCaptions16x16 } from '../constants/Glyphs';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import CheckBox from '../Checkbox';
import linkClickHandler from '../utils/link-click-handler';
import Avatar from '../Avatar';
import { getClassName } from '../utils/get-class-name';
import TscAvatarSize from '../constants/TscAvatarSize';
import TscMediaOrganizationType from '../constants/TscMediaOrganizationType';
var structure = {
  lineHeight: 1.25
};
var themes = (_themes = {}, _defineProperty(_themes, TscThemeName.dawn, {
  cardBaseBackground: tscStyles.color.ui.dawn.light,
  cardTitleColor: tscStyles.color.text.mediumDark,
  cardDateColor: tscStyles.color.text.medium,
  thumbnailContainer: tscStyles.color.ui.dawn.lightMedium
}), _defineProperty(_themes, TscThemeName.dusk, {
  cardBaseBackground: tscStyles.color.ui.dusk.medium,
  cardTitleColor: tscStyles.color.text.light,
  cardDateColor: tscStyles.color.text.lightMedium,
  thumbnailContainer: tscStyles.color.action.secondaryDusk
}), _themes);
var fadein = keyframes(["from{opacity:0;}to{opacity:1;}"]);
var SecondaryDetails = styled.a.withConfig({
  displayName: "MediaCard__SecondaryDetails"
})(["position:absolute;top:0;right:0;bottom:0;left:0;padding:.5rem;color:", ";transform:scale(1.1);transition:transform 200ms ease-out,opacity ease-out 200ms;opacity:0;text-decoration:none;display:flex;justify-content:space-between;flex-direction:column;opacity:", ";transform:", ";&:focus,&:hover{opacity:1;transform:scale(1);}&:focus-visible:before{content:'View';display:block;position:absolute;top:50%;left:50%;background:", ";color:", ";border-radius:", ";transform:translate(-50%,-50%);height:2rem;line-height:2rem;padding:0 .5rem;font-size:.875rem;white-space:nowrap;}&:active:before{display:none;}"], tscStyles.color.text.light, function (props) {
  return props.isFocused || props.showDetails ? '1' : '0';
}, function (props) {
  return props.isFocused || props.showDetails ? 'scale(1)' : 'scale(1.1)';
}, tscStyles.color.action.primary, tscStyles.color.text.light, tscStyles.border.radius.md);
var SecondaryDetailRow = styled.div.withConfig({
  displayName: "MediaCard__SecondaryDetailRow"
})(["width:100%;display:flex;box-sizing:border-box;padding-left:", ";padding-right:", ";"], function (props) {
  return props.hasLeftPadding ? '2rem' : 0;
}, function (props) {
  return props.hasRightPadding ? '3rem' : 0;
});
var SecondaryDetail = styled.div.withConfig({
  displayName: "MediaCard__SecondaryDetail"
})(["font-size:.875rem;color:", ";background:rgba(0,0,0,.7);border-radius:", ";padding:0 .375rem;height:1.5rem;white-space:nowrap;display:flex;align-items:center;margin-right:.5rem;overflow:hidden;&:last-child{margin-right:0;}svg{margin-right:.5rem;&:last-child{margin-right:0;}}"], tscStyles.color.text.light, tscStyles.border.radius.md);
var DetailText = styled.span.withConfig({
  displayName: "MediaCard__DetailText"
})(["overflow:hidden;text-overflow:ellipsis;"]);
var DetailLink = styled.a.withConfig({
  displayName: "MediaCard__DetailLink"
})(["text-decoration:none;color:", ";overflow:hidden;text-overflow:ellipsis;&::-moz-focus-inner{border:none;outline:none;}&:focus,&:hover{outline:none;text-decoration:underline;}"], tscStyles.color.text.light);
var PrimaryDetails = styled.div.withConfig({
  displayName: "MediaCard__PrimaryDetails"
})(["position:relative;padding:.25rem .5rem .25rem .75rem;"]);
var CardTitleContainer = styled.div.withConfig({
  displayName: "MediaCard__CardTitleContainer"
})(["display:flex;margin:.5rem 0 0;height:", "rem;"], function (props) {
  return props.maxTitleLines * structure.lineHeight;
});
var CardTitleLink = styled.a.withConfig({
  displayName: "MediaCard__CardTitleLink"
})(["text-decoration:none;color:", ";overflow:hidden;&:focus,&:hover{text-decoration:underline;outline:none;}"], function (props) {
  return themes[props.themeName].cardTitleColor;
});
var CardTitle = styled.h3.withConfig({
  displayName: "MediaCard__CardTitle"
})(["font-size:1rem;font-weight:600;color:", ";line-height:", ";max-height:", "rem;margin:0;overflow:hidden;white-space:pre-wrap;-webkit-box-orient:vertical;display:-webkit-box;word-break:break-word;-webkit-line-clamp:", ";text-overflow:ellipsis;"], function (props) {
  return themes[props.themeName].cardTitleColor;
}, structure.lineHeight, function (props) {
  return props.maxTitleLines * structure.lineHeight;
}, function (props) {
  return props.maxTitleLines;
});
var MediaDate = styled.div.withConfig({
  displayName: "MediaCard__MediaDate"
})(["font-size:.875rem;color:", ";white-space:nowrap;margin-right:.5rem;text-overflow:ellipsis;overflow:hidden;width:100%;"], function (props) {
  return themes[props.themeName].cardDateColor;
});
var CardControls = styled.div.withConfig({
  displayName: "MediaCard__CardControls"
})(["display:flex;justify-content:flex-end;width:100%;align-items:center;margin-right:-.25rem;"]);
var CardFooter = styled.div.withConfig({
  displayName: "MediaCard__CardFooter"
})(["display:flex;justify-content:space-between;align-items:center;min-height:2rem;"]);
var CheckBoxContainer = styled.label.withConfig({
  displayName: "MediaCard__CheckBoxContainer"
})(["margin-right:.5rem;position:absolute;top:0;left:0;z-index:2;margin-right:0;padding:.625rem 2rem 2rem .625rem;"]);
var OwnerAvatarContainer = styled.div.withConfig({
  displayName: "MediaCard__OwnerAvatarContainer"
})(["border-radius:100%;border:2px solid ", ";background-color:", ";position:absolute;top:-1.75rem;right:.5rem;"], function (props) {
  return themes[props.themeName].cardBaseBackground;
}, function (props) {
  return themes[props.themeName].cardBaseBackground;
});
var ThumbnailContainer = styled.div.withConfig({
  displayName: "MediaCard__ThumbnailContainer"
})(["position:relative;overflow:hidden;background-color:", ";border-radius:", " ", " 0 0;&:after{content:'';display:block;padding-top:56.25%}"], function (props) {
  return themes[props.themeName].thumbnailContainer;
}, tscStyles.border.radius.lg, tscStyles.border.radius.lg);
var PreloadThumbnailImage = styled.img.withConfig({
  displayName: "MediaCard__PreloadThumbnailImage"
})(["display:none;"]);
var ThumbnailImage = styled.div.withConfig({
  displayName: "MediaCard__ThumbnailImage"
})(["transition:opacity 500ms ease;opacity:", ";background-image:url(\"", "\");background-repeat:no-repeat;background-size:cover;background-position:center center;position:absolute;top:0;bottom:0;left:0;right:0;"], function (props) {
  return props.isLoaded ? '1' : '0';
}, function (props) {
  return props.thumbnailUrl;
});
var Badge = styled.div.withConfig({
  displayName: "MediaCard__Badge"
})(["width:1.5rem;height:1.5rem;border-radius:100%;position:absolute;top:-.5rem;right:-.5rem;background:", ";color:", ";display:flex;align-items:center;justify-content:center;font-size:.625rem;font-weight:600;z-index:2;"], tscStyles.color.action.destructive, tscStyles.color.text.light);
var CardBase = styled.div.attrs(function (props) {
  return props.testId ? {
    'data-test-id': props.testId
  } : {};
}).withConfig({
  displayName: "MediaCard__CardBase"
})(["display:block;position:relative;background:", ";transition:all 200ms ease;border-radius:", ";box-shadow:", ";width:100%;min-width:10rem;max-width:", ";text-decoration:none;animation:", " 250ms ease;animation-fill-mode:none;&:focus,&:hover ", "{visibility:visible;opacity:1;transform:scale(1);}"], function (props) {
  return themes[props.themeName].cardBaseBackground;
}, tscStyles.border.radius.lg, function (props) {
  return props.isSelected ? "0 0 0 3px ".concat(tscStyles.color.action.primary) : '0 2px 6px rgba(0,0,0,.15)';
}, function (props) {
  return props.maxWidth;
}, fadein, SecondaryDetails);

var MediaCard = function MediaCard(_ref) {
  var _ref$alertCount = _ref.alertCount,
      alertCount = _ref$alertCount === void 0 ? 0 : _ref$alertCount,
      className = _ref.className,
      controls = _ref.controls,
      folderTitle = _ref.folderTitle,
      folderUrl = _ref.folderUrl,
      hasCaptions = _ref.hasCaptions,
      isSelected = _ref.isSelected,
      _ref$maxTitleLines = _ref.maxTitleLines,
      maxTitleLines = _ref$maxTitleLines === void 0 ? 3 : _ref$maxTitleLines,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? '40rem' : _ref$maxWidth,
      mediaDate = _ref.mediaDate,
      mediaDateTitle = _ref.mediaDateTitle,
      mediaDuration = _ref.mediaDuration,
      mediaUrl = _ref.mediaUrl,
      onMediaClick = _ref.onMediaClick,
      onSelect = _ref.onSelect,
      _ref$organizationType = _ref.organizationType,
      organizationType = _ref$organizationType === void 0 ? TscMediaOrganizationType.folder : _ref$organizationType,
      ownerAvatarUrl = _ref.ownerAvatarUrl,
      ownerId = _ref.ownerId,
      ownerName = _ref.ownerName,
      _ref$showDetails = _ref.showDetails,
      showDetails = _ref$showDetails === void 0 ? false : _ref$showDetails,
      testId = _ref.testId,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName,
      thumbnailUrl = _ref.thumbnailUrl,
      title = _ref.title,
      viewCount = _ref.viewCount;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isLoaded = _React$useState2[0],
      setIsLoaded = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isFocused = _React$useState4[0],
      setIsFocused = _React$useState4[1];

  var _handleImageLoaded = function _handleImageLoaded() {
    setIsLoaded(true);
  };

  var _focusCard = function _focusCard() {
    setIsFocused(true);
  };

  var _blurCard = function _blurCard() {
    setIsFocused(false);
  };

  var maxAlertCount = 99;
  var formattedAlertCount = alertCount > maxAlertCount ? '!' : alertCount;
  var glyphStyle = {
    flex: 'none',
    fill: tscStyles.color.text.light
  };
  var checkboxA11Text = "Select ".concat(title);
  var mediaOrganizationGlyph = organizationType === TscMediaOrganizationType.folder ? _jsx(Folder16x16, {
    style: glyphStyle
  }) : _jsx(Collection16x16, {
    style: glyphStyle
  });
  var displayViewCount = typeof viewCount === 'number';
  return _jsxs(CardBase, {
    className: getClassName(className, null, 'card-base'),
    isSelected: !!isSelected,
    maxWidth: maxWidth,
    testId: testId,
    themeName: themeName,
    children: [alertCount > 0 && _jsx(Badge, {
      className: getClassName(className, 'badge'),
      children: formattedAlertCount
    }), _jsxs(ThumbnailContainer, {
      className: getClassName(className, 'thumbnail-container'),
      themeName: themeName,
      children: [_jsx(PreloadThumbnailImage, {
        onLoad: _handleImageLoaded,
        src: thumbnailUrl,
        alt: "thumbnail-preload"
      }), _jsx(ThumbnailImage, {
        className: getClassName(className, 'thumbnail-image'),
        isLoaded: isLoaded,
        thumbnailUrl: thumbnailUrl
      }), !!onSelect && _jsx(CheckBoxContainer, {
        className: getClassName(className, 'checkbox-container'),
        children: _jsx(CheckBox, {
          className: className,
          onClick: onSelect,
          isChecked: !!isSelected,
          a11Text: checkboxA11Text
        })
      }), _jsxs(SecondaryDetails, {
        className: getClassName(className, 'secondary-details'),
        href: mediaUrl,
        onClick: function onClick(e) {
          return linkClickHandler(e, onMediaClick, false);
        },
        isFocused: isFocused,
        onFocus: _focusCard,
        onBlur: _blurCard,
        tabIndex: 0,
        "aria-label": title,
        showDetails: showDetails,
        children: [_jsxs(SecondaryDetailRow, {
          className: getClassName(className, 'secondary-detail-row'),
          hasLeftPadding: !!onSelect,
          hasRightPadding: false,
          children: [mediaDuration && _jsxs(SecondaryDetail, {
            className: getClassName(className, 'media-duration-secondary-detail'),
            title: mediaDuration,
            children: [_jsx(Time16x16, {
              style: glyphStyle
            }), _jsx(DetailText, {
              className: getClassName(className, 'detail-text'),
              children: mediaDuration
            })]
          }), displayViewCount && _jsxs(SecondaryDetail, {
            className: getClassName(className, 'dispaly-view-count-secondary-detail'),
            children: [_jsx(Visible16x16, {
              style: glyphStyle
            }), _jsx(DetailText, {
              className: getClassName(className, 'detail-text'),
              children: viewCount
            })]
          }), hasCaptions && _jsx(SecondaryDetail, {
            className: getClassName(className, 'has-captions-secondary-detail'),
            children: _jsx(ClosedCaptions16x16, {
              style: glyphStyle
            })
          })]
        }), _jsx(SecondaryDetailRow, {
          className: getClassName(className, 'secondary-detail-row'),
          hasLeftPadding: false,
          hasRightPadding: !!ownerAvatarUrl,
          children: folderTitle && _jsxs(SecondaryDetail, {
            className: getClassName(className, 'folder-title-secondary-detail'),
            children: [mediaOrganizationGlyph, _jsx(DetailLink, {
              className: getClassName(className, 'detail-link'),
              href: folderUrl,
              children: _jsx(DetailText, {
                className: getClassName(className, 'detail-text'),
                children: folderTitle
              })
            })]
          })
        })]
      })]
    }), _jsxs(PrimaryDetails, {
      className: getClassName(className, 'primary-details'),
      children: [(ownerAvatarUrl || ownerName || ownerId) && _jsx(OwnerAvatarContainer, {
        className: getClassName(className, 'owner-avatar-container'),
        themeName: themeName,
        children: _jsx(Avatar, {
          className: className,
          avatarImageUrl: ownerAvatarUrl,
          userDisplayName: ownerName,
          userID: ownerId,
          size: TscAvatarSize.mediumLarge
        })
      }), _jsx(CardTitleContainer, {
        className: getClassName(className, 'card-title-container'),
        maxTitleLines: maxTitleLines,
        children: _jsx(CardTitleLink, {
          className: getClassName(className, 'card-title-link'),
          href: mediaUrl,
          onClick: function onClick(e) {
            return linkClickHandler(e, onMediaClick, false);
          },
          onFocus: _blurCard,
          themeName: themeName,
          children: _jsx(CardTitle, {
            className: getClassName(className, 'card-title'),
            maxTitleLines: maxTitleLines,
            title: title,
            themeName: themeName,
            children: title
          })
        })
      }), _jsxs(CardFooter, {
        className: getClassName(className, 'card-footer'),
        children: [mediaDate && _jsx(MediaDate, {
          className: getClassName(className, 'media-date'),
          title: mediaDateTitle || mediaDate,
          themeName: themeName,
          children: mediaDate
        }), _jsx(CardControls, {
          className: getClassName(className, 'card-controls'),
          children: controls
        })]
      })]
    })]
  });
}; // this names the component properly in Styleguidist, should have no other effect


MediaCard.displayName = 'MediaCard';
var MediaCardTest = {
  Badge: Badge,
  CardBase: CardBase,
  CardTitleLink: CardTitleLink,
  SecondaryDetails: SecondaryDetails
};
export { MediaCard, MediaCardTest };
export default MediaCard;